import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Navbar from '../navigation/Navbar';
import { useScrollTop } from '../../hooks/useScrollTop';

export default function PublicLayout() {
  const { user } = useAuth();
  const location = useLocation();
  useScrollTop(); // Ajout du hook ici

  // Rediriger vers le dashboard uniquement si l'utilisateur est connecté
  // et qu'il essaie d'accéder à une page d'authentification
  if (user && ['/signin', '/signup', '/forgot-password', '/reset-password'].includes(location.pathname)) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Outlet />
    </div>
  );
}